import type { ResolutionStep } from '@library/types/resolutions/resolutionDetails';

export const resolutionSteps: Array<Pick<ResolutionStep, 'idx' | 'name'>> = [
  {
    idx: 1,
    name: 'Setup'
  },
  {
    idx: 2,
    name: 'Configuration'
  },
  {
    idx: 3,
    name: 'Preview'
  },
  {
    idx: 4,
    name: 'Process'
  },
  {
    idx: 5,
    name: 'Summary'
  }
];
